import type { Num } from "../types";

const nf0 = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 });
const nf1 = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 1, minimumFractionDigits: 1 });
const nf2 = new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 2 });
const compact = new Intl.NumberFormat("ru-RU", { notation: "compact", maximumFractionDigits: 1 });

export const fmt = {
  int: (v: Num) => (v == null ? "—" : nf0.format(v)),
  idx: (v: Num) => (v == null ? "—" : nf0.format(v)),
  pct: (v: Num) => (v == null ? "—" : `${nf1.format(v)}%`),
  signedPct: (v: Num) => (v == null ? "—" : `${v > 0 ? "+" : ""}${nf2.format(v)}%`),
  signed: (v: Num) => (v == null ? "—" : `${v > 0 ? "+" : ""}${nf0.format(v)}`),
  price: (v: Num) => {
    if (v == null) return "—";
    const abs = Math.abs(v);
    return new Intl.NumberFormat("ru-RU", { maximumFractionDigits: abs >= 1000 ? 0 : abs >= 10 ? 2 : 4 }).format(v);
  },
  compact: (v: Num) => (v == null ? "—" : compact.format(v)),
  date: (iso: string | null) => {
    if (!iso) return "—";
    const [y, m, d] = iso.split("-");
    return `${d}.${m}.${y}`;
  },
  shortDate: (iso: string) => {
    const [y, m, d] = iso.split("-");
    return `${d}.${m}.${y.slice(2)}`;
  },
};

/** Зона индекса 0–100 по порогам книги (80/20). */
export function zoneOf(v: Num, hi = 80, lo = 20): "bull" | "bear" | "mid" | "none" {
  if (v == null) return "none";
  if (v >= hi) return "bull";
  if (v <= lo) return "bear";
  return "mid";
}

export const CATEGORY_LABEL: Record<string, string> = {
  currency: "Валюта",
  index: "Индексы",
  equity: "Акции",
  metal: "Металлы",
  energy: "Энергоносители",
  agri: "Сельхозтовары",
  rates: "Ставки",
  crypto: "Криптовалюта",
  other: "Прочее",
};

export const CATEGORY_ORDER = ["currency", "index", "metal", "energy", "agri", "rates", "crypto", "equity", "other"];
